import React from 'react';
import Select from 'apollo-react/components/Select';
import MenuItem from 'apollo-react/components/MenuItem';
import Info from 'apollo-react-icons/Info';

const SelectInput = ({
  field = {},
  meta = {},
  label,
  placeholder,
  options,
  onChange,
  value,
  required,
  disabled = false,
  fullWidth = true,
  helpText,
}) => {
  return (
    <Select
      {...field}
      label={
        <span
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 4,
            lineHeight: '21px',
          }}
        >
          {label} {<Info fontSize="extraSmall" style={{ color: '#595959' }} />}
        </span>
      }
      error={meta.touched && !!meta.error}
      value={value}
      helperText={meta.touched && meta.error ? meta.error : helpText || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth={fullWidth}
      required={required}
      placeholder={placeholder}
      disabled={disabled}
    >
      {options?.map((option) => (
        <MenuItem
          key={option.key}
          value={option.key}
          disabled={option.disabled || false}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectInput;
